<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span style="font-weight: bold;"><i class="el-icon-data-line text-blue" style="margin-right: 5px;"></i>流量趋势</span>
      <i :class="isExpanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" class="expand-icon" @click="toggleExpand"></i>
    </div>

    <div v-show="isExpanded" v-loading="loading" class="chart-container">
      <div ref="trendChart" style="width: 100%; height: 240px;"></div>
    </div>
  </el-card>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'Trend',
  props: {
    targetType: {
      type: String,
      default: 'department'
    },
    url: {
      type: String,
      default: 'zhaoshang/zongjian/trend'
    },
    employeeId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isExpanded: true,
      loading: false,
      chart: null,
      data: {
        month: [],
        traffic: [],
        dealCount: []
      }
    }
  },
  created () {
    // this.fetchData()
  },
  watch: {
    employeeId: {
      handler () {
        if (this.employeeId) {
          this.fetchData()
        }
      },
      immediate: true
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    if (this.chart) {
      this.chart.dispose()
    }
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    toggleExpand () {
      this.isExpanded = !this.isExpanded
      if (this.isExpanded) {
        this.$nextTick(() => {
          this.initChart()
        })
      }
    },
    async fetchData () {
      this.loading = true
      try {
        const params = {
          target: this.targetType
        }
        if (this.employeeId) {
          params.employeeId = this.employeeId
        }

        const { data: res } = await this.$http.get(this.url, {
          params
        })

        if (res.meta.status === 200) {
          this.data = res.data
          this.$nextTick(() => {
            this.initChart()
          })
        } else {
          this.$message.error(res.meta.msg)
        }
      } catch (error) {
        console.error(error)
        this.$message.error('获取趋势数据失败')
      } finally {
        this.loading = false
      }
    },
    initChart () {
      if (!this.$refs.trendChart) return

      if (this.chart) {
        this.chart.dispose()
      }

      this.chart = echarts.init(this.$refs.trendChart)

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          data: ['流量', '成交数'],
          top: 10
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.data.month
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '流量',
            type: 'line',
            smooth: true,
            data: this.data.traffic,
            itemStyle: {
              color: '#409EFF'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(64, 158, 255, 0.3)'
                },
                {
                  offset: 1,
                  color: 'rgba(64, 158, 255, 0.05)'
                }
              ])
            }
          },
          {
            name: '成交数',
            type: 'line',
            smooth: true,
            data: this.data.dealCount,
            itemStyle: {
              color: '#67C23A'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(103, 194, 58, 0.3)'
                },
                {
                  offset: 1,
                  color: 'rgba(103, 194, 58, 0.05)'
                }
              ])
            }
          }
        ]
      }

      this.chart.setOption(option)
    },
    handleResize () {
      if (this.chart) {
        this.chart.resize()
      }
    }
  }
}
</script>

<style scoped>
.text-blue { color: #409EFF; }
.clearfix {
  position: relative;
}
.expand-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 16px;
  color: #909399;
  transition: all 0.3s;
}
.expand-icon:hover {
  color: #409EFF;
}
.chart-container {
  padding: 10px 0;
}
</style>
